import { RefrigeratorState } from './refrigerator.types';

import { RootState } from '~/redux/store';

export const selectSelectedRefrigerator = ({
  refrigerator,
}: RootState): RefrigeratorState['selectedRefrigerator'] =>
  refrigerator.selectedRefrigerator;

export const selectInStoreRefrigeratorsUrl = ({
  refrigerator,
}: RootState): RefrigeratorState['inStoreRefrigeratorsUrl'] =>
  refrigerator.inStoreRefrigeratorsUrl;
